'use strict';

module.exports = require('rc-pagination/lib/locale/zh_CN');


/*****************
 ** WEBPACK FOOTER
 ** ./~/antd/lib/pagination/locale/zh_CN.js
 ** module id = 1143
 ** module chunks = 0
 **/